import useMarkAllNotificationsAsRead from './useMarkAllNotificationsAsRead';

export default useMarkAllNotificationsAsRead;
export * from './useMarkAllNotificationsAsRead';
